import password from './password.vue'

password.install = function(Vue) {
  Vue.component(password.name, password)
}

export default password
